// extracted by mini-css-extract-plugin
module.exports = {"Content":"GenericPage_Content__J9jfz"};